module.exports = __webpack_public_path__ + "img/upload.8d505057.svg";